<ng-container *ngIf="exibirFormulario">
    <app-formulario-ato
            [tipoEdicao]='tipoEdicao'
            [ato]='ato'
            [tiposAto]='tiposAto'
            [orgaos]='orgaos'
            [tiposSegmento]='tiposSegmento'
            [assuntos]='assuntos'
            [anotacoes]='anotacoes'
            [segmentosTela]='segmentosTela'
            (salvar)="salvarAto($event)"
            (limpar)="limparAto($event)">
    </app-formulario-ato>
</ng-container>
